import { Typography } from "@mui/material";
import React from "react";

const FormLabel = ({
  label,
  disabled,
  required = false,
  sx = {},
  gap = true,
}) => {
  // Determine paddingTop value for empty label case
  const paddingTop =
    typeof gap === "number"
      ? `${gap}px`
      : gap === true
      ? "33px" // default gap size when true
      : "0px"; // no gap when false

  return (
    <>
      {label ? (
        <Typography
          variant="bodySmall"
          sx={{
            display: "inline-flex",
            alignItems: "flex-start", // ⭐ top align star
            color: disabled ? "var(--gray-500)" : "var(--gray-800)",
            gap: "4px", // gap between label text and star
            position: "relative",
            ...sx,
            
          }}
        >
          <span>{label}</span>
          {required && (
            <span
              style={{
                color: "var(--red-900)",
                fontSize: "14px",
                
              }}
            >
              *
            </span>
          )}
        </Typography>
      ) : (
        <Typography
          variant="bodyMedium"
          sx={{
            fontWeight: 500,
            visibility: "hidden",
            paddingTop,
            ...sx,
          }}
        />
      )}
    </>
  );
};

export default FormLabel;

